/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import authority from '../../../share/util/authorityCheck';
import vehicle from '../../../share/util/vehicle';
import api from '../../../common/api';
import handler from '../../../share/util/apiResultValidator';
import alert from '../../../share/alert';
import util from '../../../share/util/utils';
import loading from '../../../share/components/vue/ProcessingIcon';
import table from '../../../store/modules/table';
import apiService from "../../../share/util/api/service";
import cstmTable from '../../../share/components/vue/PaginationTable';

const SU_TABLE_COLUMN_NAME_MAP = [
  { mode: 'campaign', name: 'nameForDefaultTbl' }, { mode: 'update', name: 'nameForUpdateRestoreSystemTbl' }, { mode: 'restore', name: 'nameForUpdateRestoreSystemTbl' }, { mode: 'updateProgram', name: 'nameForUpdateProgramTbl' }, { mode: 'updateChange', name: 'nameForUpdateRestoreSystemTbl' }
];

export default {
  data() {
    return {
      showModalRxswin: false,
      vin: '',
      my: '',
      model: '',
      isPublished: true,
      isVisible: false,// 非公開リプロファイル一覧の表示権限
      publishedTableItems: [],
      unpublishedTableItems: [],
      processing: false,
      isLoading: false, // b-overlay用
      rxswins: '',

      /** HTML 非バインド変数 */
      selectedUnit: {},
      sortCol: '',
      sortDir: config.DESC,
      relatedReproSystemName: '',
      reprogramTableTypes: [],

      // アップデートプログラム表示時の判定用フラグ
      updateProgramFlg: false,
      // シリアルNO入力ダイアログ表示用フラグ
      showModalSerialNo: false,
      // シリアルNo入力用変数
      inputSerialNo: '',
    };
  },
  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
  },

  props: {
    tableData: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  watch: {
    tableData(tbl) {
      if (!tbl || !tbl.published) return;
      this.updateTargetUnitDisplayName(tbl.published || [], tbl.unpublished || []);
      this.computeVisible();
      this.computeTableTypes();
    },

    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        if (this.displayReproTypeMode === "updateProgram") {
          // 商品選択画面
          this.filterUpdateProgramTable();
        } else if (this.displayReproTypeMode === "updateChange") {
          // 商品選択後の画面
          this.filterUpdateRestoreSystemTable();
          this.$emit('getPfcFile', this.selectMerchandiseInfo);
          this.filterUpdateRestoreSystemTable();
        } else {
          this.updateTargetUnitDisplayName(this.publishedTableItems, this.unpublishedTableItems);
        }
      }
    },
  },

  computed: {
    ...mapState({
      authGroup: state => state.userProperty.group,
      displayMode: state => state.cache.showPublished,
      resources: state => state.masterResources.targetUnits,
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      dialogContents: state => state.cache.dialogContents,
      displayReproTypeMode: state => state.cache.showDisplayVehicle,
      merchandiseInfo: state => state.cache.merchandiseInfo,
      updateProgramInfo: state => state.cache.updateProgramInfo,
      serialNumber: state => state.cache.serialNumber,
      selectMerchandiseInfo: state => state.cache.selectMerchandiseInfo,
      beforeTransitionTable: state => state.cache.beforeTransitionTable,
      // TS連携でシステム画面から戻った場合は初期化を実施する
      needInitializationProcess: state => state.app.directMove && state.app.directMove.direct_name === 'systemInformation'
    }),
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('targetUnit', ['setTargetUnit']),
    ...mapActions('cache', ['cacheDialogContents', 'cacheSystemIdsInfo', 'cacheCcuReproInfo', "cacheSerialNumber", "cacheUpdateProgramInfo", "cacheMerchandiseInfo", "cacheSelectMerchandiseInfo", "cacheBeforeTransitionTable"]),

    // 任意のシステムが選択されたことを親に通知
    showDetails: function (selected) {
      // アップデートプログラムのリストから選択されたとき
      if (this.displayReproTypeMode === "updateProgram") {
        // 商品一覧画面で商品が選択されたとき
        if (selected.verificationType === "password") {
          // 任意のシステムが押されたこと/情報を親に通知
          this.$emit('selectReproTableRow', selected);
          // パスワード管理の場合は商品一覧画面での照合は必要ないので、商品に紐づくユニット一覧をそのまま表示する
          this.showUpdateRestoreSystem();
          this.updateProgramFlg = false;

          // パスワードを使用する場合、不要なシリアルNoのキャッシュをクリアする
          this.cacheSerialNumber(null);
        } else {
          // シリアル管理の場合シリアル番号入力ダイアログを表示する
          this.selectedCache = selected;
          this.showModalSerialNo = true;
        }
        // 以降の処理は商品選択時に不要なのでreturnする
        return;
      }

      if (this.displayReproTypeMode === 'updateChange') {
        // 商品に紐づくリプロありのシステムが選択されたとき、リプロ種別に応じてdisplayReproTypeModeを変更する
        if (selected.showDetail.merchant === true) {
          this.$emit('changeTableTypes', 'update');
        } else if (selected.showDetail.restore === true) {
          this.$emit('changeTableTypes', 'restore');
        }
      }

      // 選択されたシステムの CID/ROMID/SWID を保持
      this.cacheSystemIdsInfo({ currentId: (selected.isCcuSystem ? selected.swid : selected.targetId) });
      // CCUのキャッシュをクリア
      this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });

      // SU法規対象 Type2 の表示システム名を設定
      selected.type2DisplayUnitId = util.getType2DisplayUnitId(selected.id, this.resources);
      this.$emit('selectReproTableRow', selected);
      return;
    },

    // 公開・非公開テーブルの切り替え
    switchTable: function () {
      this.isPublished = !this.isPublished;
      this.$emit('switchPublishmentMode', this.isPublished);
    },

    // 非公開リプロの可否を判断
    computeVisible: function () {
      // サインインユーザーがシステム管理者・サービス管理者・SBRリプロ評価者か
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      /**
       * 下記のいずれかを満たす場合は「非公開ファイル一覧へ」ボタンを表示しない
       * 1. 非公開ファイル一覧の応答が空配列
       */
      let hasTarget = false;
      if (this.tableData.unpublished && this.tableData.unpublished.length > 0) {
        hasTarget = true;
      }
      this.isVisible = auth && hasTarget;
      // 非公開ファイル一覧を表示する必要がないなら、「非公開ファイル一覧へ」ボタンを表示する必要もない
      if (!this.isVisible) {
        this.isPublished = true;
        this.$emit('switchPublishmentMode', this.isPublished);
      }
    },

    // Update target unit display name
    updateTargetUnitDisplayName: function (publishedList, unpublishedList) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const publishedTableItemsTemp = [...publishedList];
      const unpublishedTableItemsTemp = [...unpublishedList];
      const name = SU_TABLE_COLUMN_NAME_MAP.filter(e => e.mode === this.displayReproTypeMode)[0].name;
      publishedTableItemsTemp.forEach(element => element[name] = targetUnitDisplayData[`${element.id}`] || '');
      unpublishedTableItemsTemp.forEach(element => element[name] = targetUnitDisplayData[`${element.id}`] || '');
      const specialHandlingSort = this.computeSortOrder(publishedTableItemsTemp || [], unpublishedTableItemsTemp || []);
      this.publishedTableItems = specialHandlingSort.published;
      this.unpublishedTableItems = specialHandlingSort.unpublished;
    },

    /* eslint-disable complexity */
    sortCompare: function (key) {
      if (this.sortCol === key) {
        this.sortDir = this.sortDir === config.DESC ? config.ASC : config.DESC;
      }
      this.sortCol = key;
      const isDesc = this.sortDir === config.DESC;
      function calc(a, b) {
        if (key === 'defaultDetail' || key === 'updateDetail' || key === 'restoreDetail') {
          const aVal = a[key];
          const bVal = b[key];
          if (aVal && !bVal) return isDesc ? 1 : -1;
          if (!aVal && bVal) return isDesc ? -1 : 1;
          return 0;
        }
        if (key === 'nameForUpdateRestoreSystemTbl' || key === 'nameForDefaultTbl' || key === 'nameForUpdateTbl' || key === 'nameForRestoreTbl' || key === 'hwid' || key === 'swid' || key === 'targetId') {
          if (a[key] < b[key]) return isDesc ? -1 : 1;
          if (a[key] > b[key]) return isDesc ? 1 : -1;
          return 0;
        } else {
          return isDesc ? a[key].order - b[key].order : b[key].order - a[key].order;
        }
      }
      return this.isPublished ? this.publishedTableItems.sort(calc) : this.unpublishedTableItems.sort(calc);
    },

    // 対象ユニットIDをシステム名に変換する関数
    putSystemName: function (unitId) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const unitName = targetUnitDisplayData[unitId];
      return unitName;
    },

    // 公開/非公開ファイル一覧から関連リプロ対象システムを取得する関数
    getRelationReproMessage: function () {
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      // related_repro_flag = true のみフィルタ
      const relationPbl = this.publishedTableItems.filter(item => item.isRelatedRepro);
      const relationUnpbl = auth ? this.unpublishedTableItems.filter(item => item.isRelatedRepro) : [];
      // 関連リプロ中システムが 1 つ以上なら、id ⇒ ユニット名に変換し、リストに格納
      const pblNameConverted = relationPbl.map(system => this.putSystemName(system.id));
      const unpblNameConverted = relationUnpbl.length > 0 ? relationUnpbl.map(system => this.putSystemName(system.id)) : [];
      // ダイアログの文言を生成
      const pblMessageText = pblNameConverted && pblNameConverted.length > 0 ? pblNameConverted.join(', ') : '';
      const unpblMessageText = unpblNameConverted && unpblNameConverted.length > 0 ? unpblNameConverted.join(', ') : '';
      let msg = this.$t('message.message_vehicle_continuous_repro_system_exist') + '<br/>' + this.$t('message.message_vehicle_repro_execution_below') + '<br/>';
      if (auth && relationUnpbl.length > 0) {
        // 非公開システムの表示権限有、かつ関連リプロ中の非公開システムが存在する場合は、公開・非公開の一覧を分ける
        msg = msg + '<br/>' + this.$t('message.label_vehicle_published') + '<br/>' + pblMessageText;
        msg = msg + '<br/>' + this.$t('message.label_vehicle_unpublished') + '<br/>' + unpblMessageText;
      } else {
        msg = msg + '<br/>' + pblMessageText;
      }
      return relationPbl.length < 1 && relationUnpbl.length < 1 ? '' : msg;
    },

    openRxswinModal: async function () {
      let rxswinList = [];
      this.processing = true;
      const response = await api.getCall(config.REPRO, '/netApps/' + this.netAppId + '/vehicle/rxswins');
      this.processing = false;
      handler.validate(handler.validateTypes.all, response, this, null, () => {
        rxswinList = response.data.rxswins;
        if (rxswinList.length !== 0) {
          // RxSwinを昇順に並び変える
          rxswinList.sort((a, b) => { return a > b ? 1 : -1; });
        } else {
          // RxSWINが空の場合"-"(ハイフン)を表示する
          rxswinList.push('-');
        }
        this.rxswins = rxswinList;
        this.showModalRxswin = true;
      }, (result) => {
        // エラーダイアログの表示
        alert.showError(this, null, result.message, () => {
          // 処理が失敗した際にdialogが表示されていたら閉じる
          this.showModalRxswin = false;
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
        return;
      }, null, false);
    },

    // RxSWINをクリップボードにコピーする関数
    copyRxswin: function () {
      // RxSWINを改行で区切る
      const clipboardText = this.rxswins.join('\n');

      //ブラウザで分岐
      if (window.clipboardData) { // IE
        window.clipboardData.setData('Text', clipboardText);
      } else { // any browser
        navigator.clipboard.writeText(clipboardText);
      }
      this.showModalRxswin = false;
    },

    setupSuTableColumn: function () {
      const columns = {
        default: [
          { key: 'nameForDefaultTbl', label: 'message.header_vehicle_system_table_unit' },
          { key: 'hwid', label: 'message.header_vehicle_system_table_hwid' },
          { key: 'swid', label: 'message.header_vehicle_system_table_swid' },
          { key: 'targetId', label: 'message.label_vehicle_system_ids' },
          { key: 'normalReproResource', label: 'message.header_vehicle_system_table_has_repro_data', useResource: true },
          { key: 'defaultDetail', label: 'message.header_vehicle_system_table_details' },
          { key: 'installationResource', label: 'message.header_vehicle_system_table_installation' },
          { key: 'communicableResource', label: 'message.header_vehicle_system_table_communication' }
        ],
        updateChange: [
          { key: 'nameForUpdateRestoreSystemTbl', label: 'message.header_vehicle_system_table_unit' },
          { key: 'hwid', label: 'message.header_vehicle_system_table_hwid' },
          { key: 'swid', label: 'message.header_vehicle_system_table_swid' },
          { key: 'targetId', label: 'message.label_vehicle_system_ids' },
          { key: 'updateReproResource', label: 'message.header_vehicle_system_table_has_update_reprogrammable' },
          { key: 'restoreReproResource', label: 'message.header_vehicle_system_table_has_restore_version_reprogrammable' },
          { key: 'restoreDetail', label: 'message.header_vehicle_system_table_details' },
          { key: 'installationResource', label: 'message.header_vehicle_system_table_installation' },
          { key: 'communicableResource', label: 'message.header_vehicle_system_table_communication' }
        ],
        updateProgram: [
          { name: "nameForUpdateProgramTbl", label: "message.header_vehicle_update_program_table" }
        ]
      };
      return columns[this.displayReproTypeMode] ?? columns.default;
    },

    // 機能向上/復元リプロ対象製品のリストを表示する
    showUpdateRestoreSystem: function () {
      // displayReproTypeMode→updateChange
      this.$emit('changeTableTypes', 'updateChange');
      // 機能向上/復元リプロ対象製品テーブルの作成
      this.filterUpdateRestoreSystemTable();
    },

    // 機能向上/復元リプロ対象製品用のテーブルを作成
    filterUpdateRestoreSystemTable: function () {
      // リプロ有/無を判別するメッセージ定義
      const prefix = 'message.a_';

      const publishedList = this.merchandiseInfo.published || [];
      const unpublishedList = this.merchandiseInfo.unpublished || [];

      const filterReprogrammableUnit = ((merchandiseInfo) => {
        // 機能向上・復元のいずれかがリプロありのユニットのみ残す
        return merchandiseInfo.filter(unitInfo => unitInfo.updateReproResource.label.startsWith(prefix) || unitInfo.restoreReproResource.label.startsWith(prefix));
      });
      const systemPublishList = (filterReprogrammableUnit(publishedList));
      const systemUnPublishList = (filterReprogrammableUnit(unpublishedList));
      // フィルタしたユニット情報を画面に反映する。
      this.updateTargetUnitDisplayName(systemPublishList, systemUnPublishList);
    },

    // アップデートプログラムの表示
    showUpdateProgramList: function () {
      this.updateProgramFlg = true;
      // DisplayModeをupdateProgramに変更する。
      this.$emit('changeTableTypes', 'updateProgram');
      // アップデートプログラム用のリストの作成
      this.filterUpdateProgramTable();
      // 特約店専用メニュー表示時の公開/非公開判定
      this.computeVisibleForUpdateProgramList();
    },

    // アップデートプログラムリストの作成
    filterUpdateProgramTable: function () {
      // 格納対象のテーブルの初期化
      this.unpublishedTableItems = [];
      this.publishedTableItems = [];
      // アップデートプログラムのキャッシュをクリア
      this.cacheUpdateProgramInfo("");

      // シリアルNoのキャッシュをクリアする
      this.cacheSerialNumber(null);

      // 公開アップデートプログラムリストの作成
      const publishedRes = this.createUpdateProgramTable(table.state.merchandiseTable.pub);
      this.publishedTableItems = publishedRes;

      // 非公開アップデートプログラムリストの作成
      const unpublishedRes = this.createUpdateProgramTable(table.state.merchandiseTable.unpub);
      this.unpublishedTableItems = unpublishedRes;

      // 作成したアップデートプログラムリストをキャッシュに保存
      this.cacheUpdateProgramInfo({ publishedTableItems: this.publishedTableItems, unpublishedTableItems: this.unpublishedTableItems });

    },

    //アップデートプログラムリストを作成する
    createUpdateProgramTable: function (updateProgramTable) {
      const updateProgramItem = [];
      for (const merchandiseCodeDetails of updateProgramTable) {
        for (const displayName of merchandiseCodeDetails.data.display_names) {
          // 選択中の言語と一致する表示名称が存在していれば、アップデートプログラム一覧の表示に商品情報を追加する
          if (displayName.language === this.language) {
            updateProgramItem.push({
              nameForUpdateProgramTbl: displayName.name,
              merchandiseCode: merchandiseCodeDetails.data.merchandise_code,
              verificationType: merchandiseCodeDetails.data.verification_type,
            });
          }
        }
      }
      return updateProgramItem;
    },

    // 特約店専用メニュー表示時の公開/非公開判定
    computeVisibleForUpdateProgramList: function () {

      // 公開/非公開ボタンの表示/非表示を判定する
      // サインインユーザーがシステム管理者・サービス管理者・SBRリプロ評価者か
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      /**
       * 下記を満たす場合は「非公開ファイル一覧へ」ボタンを表示しない
       * 1. 非公開商品コード一覧の応答が空配列
       */
      const hasTarget = this.unpublishedTableItems.length !== 0;
      this.isVisible = auth && hasTarget;
      // 非公開ファイル一覧を表示する必要がないなら、「非公開ファイル一覧へ」ボタンを表示する必要もない
      if (!this.isVisible) {
        this.isPublished = true;
        this.$emit('switchPublishmentMode', this.isPublished);
      }
    },

    // シリアル番号が5桁目の入力時に自動で「-」を挿入する
    serialNoFormatter: function (inputValue, event) {
      if (event.type === "input" && inputValue.length === 5) {
        return inputValue + "-";
      }
      return inputValue;
    },

    validateInputSerialNo: function () {
      this.showModalSerialNo = false;
      //入力値が空の場合は処理を終了
      if (!this.inputSerialNo) {
        const messages = this.$t("message.message_repro_merchantability_serial_error");
        alert.showError(this, null, messages, () => {
          this.inputSerialNo = '';
          this.processing = false;
          this.showModalSerialNo = true;
        });
        return;
      }
      //シリアル番号を認証する
      this.confirmSerialNo();
    },

    //シリアル番号認証
    confirmSerialNo: async function () {
      const merchandise_code = this.selectedCache.merchandiseCode;
      // くるくる表示
      this.processing = true;
      const isSerialNo = await apiService.postCall(
        config.REPRO,
        '/merchandise/' + merchandise_code + '/serialNumbers/confirm',
        {
          net_app_id: this.netAppId,
          serial_number: this.inputSerialNo
        }
      );
      this.processing = false;
      handler.validate(
        handler.validateTypes.all,
        isSerialNo, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          if (isSerialNo.data.is_confirmed === true) {
            this.cacheSerialNumber(this.inputSerialNo);
            this.$emit('selectReproTableRow', this.selectedCache);
            this.$emit('serialNoDialog', this.inputSerialNo);
            // シリアル番号の照合に成功したら、商品に紐づくユニット一覧を表示する
            this.showUpdateRestoreSystem();
            this.inputSerialNo = '';
            this.updateProgramFlg = false;
          } else {
            // エラーを出して入力ダイアログに戻る
            const messages = this.$t("message.message_repro_merchantability_serial_error");
            alert.showError(this, null, messages, () => {
              this.inputSerialNo = '';
              this.showModalSerialNo = true;
            });
          }
        },
        (result) => {
          // 処理が失敗したときのコールバック処理
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
        }
      );
    },


    // 詳細情報有無判定
    isDetail: function (item) {
      if (this.displayReproTypeMode === 'campaign') {
        // 市場措置・その他で1件でも詳細有りが存在する場合：詳細ボタンを表示
        return item.showDetail.normal;
      } else if (this.displayReproTypeMode === 'updateChange') {
        if (item.reproExecutable.merchant.order === 0) {
          return item.showDetail.merchant;
        } else if (item.reproExecutable.restore.order === 0) {
          return item.showDetail.restore;
        }
      }
      return false;
    },

    // テーブルごとのソフトウェア許諾・詳細のソート実施に必要な事前処理
    computeSortOrder: function (pblTbl, unpblTbl) {
      let mapPblTblSpecial = "";
      let mapUnpblTblSpecial = "";
      // 公開のテーブルが存在する時
      mapPblTblSpecial = pblTbl.map((e) => {
        return {
          ...e,
          defaultReproExecute: e.reproExecutable.normal,
          updateReproExecute: e.reproExecutable.merchant,
          restoreReproExecute: e.reproExecutable.restore,
          defaultDetail: e.showDetail.normal,
          updateDetail: e.showDetail.merchant,
          restoreDetail: e.showDetail.restore,
        };
      });
      // 非公開のテーブルが存在する時
      mapUnpblTblSpecial = unpblTbl.map((e) => {
        return {
          ...e,
          defaultReproExecute: e.reproExecutable.normal,
          updateReproExecute: e.reproExecutable.merchant,
          restoreReproExecute: e.reproExecutable.restore,
          defaultDetail: e.showDetail.normal,
          updateDetail: e.showDetail.merchant,
          restoreDetail: e.showDetail.restore,
        };
      });
      return { published: mapPblTblSpecial, unpublished: mapUnpblTblSpecial };
    },

    // 開いた画面の状態を保持
    computeTableTypes: function () {
      this.reprogramTableTypes = [];
      if (this.tableData.published) {
        for (const ecu of this.tableData.published) {
          const isUpdateRpr = ecu.updateReproResource && ecu.updateReproResource.label.startsWith('message.a_');
          const isRestoreRpr = ecu.restoreReproResource && ecu.restoreReproResource.label.startsWith('message.a_');
          if (isUpdateRpr && !this.reprogramTableTypes.includes('update')) this.reprogramTableTypes.push('update');
          if (isRestoreRpr && !this.reprogramTableTypes.includes('restore')) this.reprogramTableTypes.push('restore');
        }
      }
      if (!this.isVisible) return;
      if (this.tableData.unpublished) {
        for (const ecu of this.tableData.unpublished) {
          const isUpdateRpr = ecu.updateReproResource && ecu.updateReproResource.label.startsWith('message.a_');
          const isRestoreRpr = ecu.restoreReproResource && ecu.restoreReproResource.label.startsWith('message.a_');
          if (isUpdateRpr && !this.reprogramTableTypes.includes('update')) this.reprogramTableTypes.push('update');
          if (isRestoreRpr && !this.reprogramTableTypes.includes('restore')) this.reprogramTableTypes.push('restore');
        }
      }
    },

    // 機能向上・以前のバージョンに復元画面から市場措置/その他画面へ戻る
    back: function () {
      // アップデートプログラムからvehicle画面への画面遷移
      if (this.displayReproTypeMode === "updateProgram") {
        //選択した商品コードのキャッシュをクリア
        this.cacheSelectMerchandiseInfo("");
        // 商品コードの情報のキャッシュをクリア
        this.cacheMerchandiseInfo({ published: null, unpublished: null });

        // tableDataに初期表示のキャッシュをセット
        // tableDataに変更が入るのでwatch内の処理が発生する
        this.tableData.published = this.beforeTransitionTable.published;
        this.tableData.unpublished = this.beforeTransitionTable.unpublished;
        // displayReproTypeMode → campaign
        this.$emit('changeTableTypes', 'campaign');
        // 画面表示を初期表示のキャッシュで切り替え
        this.updateTargetUnitDisplayName(this.tableData.published || [], this.tableData.unpublished || []);
        this.computeTableTypes();
        this.computeVisible();
        return;
      }
      // アップデートプログラムへの画面遷移
      this.$emit('changeTableTypes', 'updateProgram');
      this.cacheSerialNumber(null);
      this.showUpdateProgramList();
    },

    // テーブルのツールチップ表示
    onMouseHover: function (data) {
      if (data && data.popup) {
        // 取得した値が「-」の場合はエラー文言を表示する。
        if ('message.common_hyphen' === data.rowData.value) {
          const msgMap = [
            { name: 'normalReproResource', msgId: 'message.label_id_not_read' },
            { name: 'updateResource', msgId: 'message.label_id_not_read' },
            { name: 'restoreResource', msgId: 'message.label_id_not_read' },
            { name: 'installationResource', msgId: 'message.label_unit_not_read' },
            { name: 'communicableResource', msgId: 'message.label_connection_not_read' },
          ];
          const filtered = msgMap.filter(m => m.name === data.rowData.columnName);
          data.popup.name = this.$t(filtered.length > 0 ? filtered[0].msgId : '');
        }
      }
    },

    // cid/romidの背景色の設定 
    // swid背景色の設定
    setBgStyle: function (item, type) {
      if (this.displayReproTypeMode === 'campaign') {
        return item.bgStyle[type].normal;
      }
      else if (this.displayReproTypeMode === 'updateChange') {
        if (item.reproExecutable.merchant.order === 0) {
          return item.bgStyle[type].merchant;
        }
        if (item.reproExecutable.restore.order === 0) {
          return item.bgStyle[type].restore;
        }
      }
      return '';
    },
  },

  created() {
    // noop
  },

  mounted() {
    // タブの表示の切り替え
    this.$emit('setVehicleTabsAvailable', true);
    // 選択中の対象ユニットを初期化
    this.setTargetUnit(null);
    // 公開・非公開どちらのファイル一覧が表示中なのかを初期化
    this.isPublished = this.displayMode;
    // 表示するtableの初期化
    this.updateTargetUnitDisplayName(this.tableData.published || [], this.tableData.unpublished || []);
    // 非公開のリプロを触れる権限のアクセスかを判定/非公開のリプロがあるかを判定
    this.computeVisible();
    // 開いた画面の状態を保持する
    this.computeTableTypes();

    // リプロ結果画面から戻ってきたとき、表示しなければならないダイアログ Queue があれば表示
    // 車両通信後に Vehicle 画面が表示されるユースケースでは、このダイアログ Queue 表示を
    // InformationMain 側で実施するので、ここでは result からの復帰の分岐が必要
    if (util.getPreviousDisplayName(this.$route) === 'result') {
      this.$emit('runModalQueue');
    }
    // 選択中の対象ユニットのRomIDを初期化
    this.cacheSystemIdsInfo({ currentId: null, newIds: [] });
    // CCUのリプロ情報を初期化
    this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });

    // Menu取得画面以外の画面から遷移した場合はキャッシュ情報を使用する。
    if (util.getPreviousDisplayName(this.$route) !== 'menu' && !this.needInitializationProcess) {
      // 機能向上/復元のリプロ実行後の場合
      if (["update", "restore"].includes(this.displayReproTypeMode)) {
        // 結果画面からの画面遷移時
        if (util.getPreviousDisplayName(this.$route) === 'result') {
          // キャッシュにpublished/unpublishedの情報を格納しなおす
          this.cacheBeforeTransitionTable({ published: this.tableData.published, unpublished: this.tableData.unpublished });
        }
        // キャッシュしておいた選択した商品コードを利用して、再度リプロあり製品を取得
        this.$emit('getPfcFile', this.selectMerchandiseInfo);
        // 取得した商品を対象にテーブルを再作成
        this.filterUpdateRestoreSystemTable();
        // displayReproTypeMode → updateChange
        this.$emit('changeTableTypes', 'updateChange');
      } else {
        // 品質改善リプロの場合
        const isAfterRepro = ['result', 'systemFileTable'].includes(util.getPreviousDisplayName(this.$route));
        // リプロ後の画面から遷移してきた場合は、リプロ後に取得したpublished/unPublishedの結果でテーブル更新する
        // 商品選択後の画面から遷移してきた場合は、キャッシュに保存したpublished/unPublishedの結果でテーブルを更新する
        const targetTableData = isAfterRepro ? this.tableData : this.beforeTransitionTable;
        this.updateTargetUnitDisplayName(targetTableData.published || [], targetTableData.unpublished || []);
        this.cacheBeforeTransitionTable({ published: targetTableData.published, unpublished: targetTableData.unpublished });
        this.$emit('changeTableTypes', this.displayReproTypeMode);
      }
    }
    else {
      // Menu情報取得からの画面表示
      // テーブルタイプをcampaignに変更/this.displayReproMode→campaign
      this.$emit('changeTableTypes', 'campaign');
      // 選択した商品コードを初期化
      this.cacheSelectMerchandiseInfo(null);
      // 機能向上/復元の製品リストを初期化
      this.cacheMerchandiseInfo({ published: null, unpublished: null });
      // キャッシュ情報で画面表示しているテーブルを初期表示(published/unpublishedの結果から)
      this.updateTargetUnitDisplayName(this.tableData.published || [], this.tableData.unpublished || []);
      // 初期表示の情報をキャッシュで保持
      this.cacheBeforeTransitionTable({ published: this.tableData.published, unpublished: this.tableData.unpublished });
    }
    // 前回指定された画面名をクリア
    // ※パラメータに画面名が設定されていない場合、前回情報を保持し続けてしまうため
    if (util.getPreviousDisplayName(this.$route) !== 'execute') {
      this.$route.params.previousDisplayName = '';
    }
  }
};